/**
 * 改行コードを<br>に変換する
 * @param str
 * @returns {string}
 */
export const nl2br = function(str){
    return (str.replace(/\r\n/g, "<br />")).replace(/[\n\r]/g, "<br />");
}

/**
 * パスカルケースからキャメルケースに変換する
 * @param str
 * @returns {string}
 * */
export const pascalToCamel = (str) => str.charAt(0).toLowerCase() + str.slice(1)

/**
 * キャメルケースからケバブケースに変換する
 * @param str
 * @returns {string}
 * */
export const camelToKebab = (str) => str.replace(/([A-Z])/g, '-$1').toLowerCase()
